import { useState, useEffect, useRef } from "react";

const MainExplorer = (props) => {
  return (
    <div className="relative flex flex-col h-[calc(100vh-1rem)] overflow-x-hidden pt-[80px] px-4">
      WIP
    </div>
  );
};

export default MainExplorer;
